export default "__VITE_ASSET__BHL1tLtz__"